module.exports = __webpack_public_path__ + "img/wayfinder-mobile-ar-view-fr.88bab1cf.webp";